import * as workerTimers from 'worker-timers';

type TTimerId = number;

// worker-timers spawns its Worker lazily on the first timer call; Capacitor WKWebView CSP makes that throw, so probe once and fall back to native timers
const workerTimersUsable = (() => {
  try { workerTimers.clearInterval(workerTimers.setInterval(() => {}, 60000)); return true; } catch { return false; }
})();

export const setInterval: (fn: () => void, delay: number) => TTimerId = workerTimersUsable ? workerTimers.setInterval : (fn, delay) => window.setInterval(fn, delay);
export const clearInterval: (id: TTimerId) => void = workerTimersUsable ? workerTimers.clearInterval : (id) => window.clearInterval(id);
export const setTimeout: (fn: () => void, delay: number) => TTimerId = workerTimersUsable ? workerTimers.setTimeout : (fn, delay) => window.setTimeout(fn, delay);
export const clearTimeout: (id: TTimerId) => void = workerTimersUsable ? workerTimers.clearTimeout : (id) => window.clearTimeout(id);
